import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateDesignation = createAsyncThunk('updateDesignation', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + `designation`,
            data: {
                "designation_id": data?.values?.id,
                "designation_name": data?.values?.designationName,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
